import { createContext } from 'react';

export const AuthorContext = createContext({});